$(document).ready(function () {

    // upon hitting reset of form, let's clear out all validation errors and required fields
    $(document).find('form.front-store-item').on('reset', function() {
        const form = $(document).find('form.front-store-item');
        const fields = form.find(':input:not(#unique_materials_division)').filter('[required]');
        form.find('.errorMsg').hide();
        fields.prop('required',false).removeClass('invalid');
    });

    $("#sap_divisions_items:not(.read-only) .enable_sap_division").change(function() {
        //if ($(this).is(':checked')) {
        var enabled = $(this).is(':checked');
        var row = $(this).closest("tr");
        var division = $(this).val();

        if (enabled) {
            row.addClass("enabled").removeClass('disabled');
            row.find("input[name='sap_divisions["+division+"][division]']").val(division);
        } else {
            row.removeClass("enabled").addClass('disabled');
            row.find("input[name='sap_divisions["+division+"][division]']").val("");
        }

        row.find("input[type='text'],input[type='number'],input[type='hidden'],input[type='checkbox'],select").each(function() {
            if (!enabled) {
                $(this).removeClass("form_error");
                $(this).attr("required",false);
                if (!$(this).prop("readonly")) {
                    if ($(this).attr('type') != "hidden" && $(this).attr('type') != "checkbox") {
                        $(this).val("");
                    }
                }
                $(this).closest("td").removeClass("required");
                $(this).attr('required', false).removeClass("invalid");

                if ($(this).hasClass("division_batch_management_display")) {
                    $(this).val("");
                }

                try {
                    $(this).valid();
                }
                catch(error) {}
            }
            else {
                $(this).attr("disabled",false);
                if ($(this).hasClass("division_batch_management_display") || $(this).hasClass("division_reporting_attr")) {
                    $(this).closest("td").removeClass("required");
                    $(this).attr('required', false).removeClass("invalid");
                } else {
                    //$(this).closest("div.form-group").addClass("required");
                    if(abcsetup.item.type != 'bonus') {
                        $(this).attr("required",true);
                        $(this).closest("td").addClass("required");
                    }

                    if ($(this).hasClass("division_batch_management")) {
                        if (division == '10') {
                            $(this).val("N").attr("disabled",true);
                            // $(this).after('<input type="hidden" name="sap_divisions[10][batch_management]" value="N">');
                        }
                    }

                    var replace_item = '';
                    if ($(this).hasClass("division_replace_item")) {
                        replace_item = $(this).val();
                    }

                    if ($(this).hasClass("division_replace_sap_num")) {
                        if (replace_item == 'Y') {
                            $(this).attr("required",true);
                            $(this).closest("td").addClass("required");
                            //$(this).trigger("change");
                        }
                        else {
                            $(this).closest("td").removeClass("required");
                            $(this).attr('required', false).removeClass("invalid");
                        }
                    }
                }
            }
        });
        var unique_materials_division  = $("#unique_materials_division");
        if(unique_materials_division){
            // The next two lines could be replaced with: fieldValidate.removeOrnaments(unique_materials_division);
            unique_materials_division.removeClass('invalid');
            unique_materials_division.next('.errorMsg').remove();
            unique_materials_division.trigger("change",{revalidate: true});
        }
    }).trigger("change");

    // Fix for director role in new item setup
    $("#sap_divisions_items.read-only").find("input[type='text'],input[type='number'],input[type='hidden'],input[type='checkbox'],select").each(function() {
        $(this).attr("required",false);
    });

    $(".division_replace_item").change(function() {
        var replace_item_name = $(this).attr("name");

        if (replace_item_name != undefined) {
            var replace_item_val = $(this).val();
            var replace_sap_num_name = replace_item_name.replace("replace_item", "replace_sap_num");
            var replace_sap_num = $('input[name="'+replace_sap_num_name+'"]');
            if (replace_item_val == 'Y') {
                replace_sap_num.attr("required",true);
                replace_sap_num.closest("td").addClass("required");
            }
            else {
                replace_sap_num.closest("td").removeClass("required");
                replace_sap_num.val("").attr('required', false).removeClass("invalid");
            }
        }
    }).trigger("change");

    $('#unique_materials_division').change(function()
    {
        const checked_sap_divisions = $('#sap_divisions_items').find('.enable_sap_division:checked');
        const sap_divisions = $('#sap_divisions_items').find('.enable_sap_division');

        if($(this).val() === 'Y')
        {
            $('#sap_divisions_instructions').show();
            if(checked_sap_divisions.length < 2)
            {
                $('#sap_divisions_validator').css({
                    border: 0,
                    'outline-width': 0,
                    color: 'transparent'
                }).prop('required',true).attr('type','text');
            } else
                $('#sap_divisions_validator').prop('required',false);
        }
        else if ($(this).val() === 'N')
        {
            $('#sap_divisions_instructions').show();
            if(checked_sap_divisions.length !==  1)
            {
                $('#sap_divisions_validator').css({
                    border: 0,
                    'outline-width': 0,
                    color: 'transparent'
                }).prop('required',true).attr('type','text');
            }
            else
                $('#sap_divisions_validator').prop('required',false);
        }
        else
            $('#sap_divisions_instructions').hide();
    });

    $('.enable_sap_division').change(function()
    {
        const checked_sap_divisions = $('#sap_divisions_items .enable_sap_division:checked');
        if($('#unique_materials_division').val() === 'Y' && checked_sap_divisions.length >= 2)
        {
            $('#sap_divisions_validator').prop('required',false);
        }
        if($('#unique_materials_division').val() === 'N' && checked_sap_divisions.length == 1)
        {
            $('#sap_divisions_validator').prop('required',false);
        }
    });

    if($('#unique_materials_division').val() != '')
    {
        $('#unique_materials_division').trigger('change');
        $('#sap_divisions_instructions').show();

    }
})
